import React from "react";
import { connect } from "react-redux";
import "../Forms/css/register.css";
import axios from "axios";

const token = localStorage.getItem('authToken');

class AddLocation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            pinCodes: '', // Pin codes as a single string
            submissionStatus: null,
        };
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    handlePinCodeChange = (e) => {
        this.setState({ pinCodes: e.target.value });
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        
        const jsonData = {
            name: this.state.name,
            pincode: this.state.pinCodes // Send pin codes as a single string
        };

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                }
            };

            const response = await axios.post("https://brand.aasmo.in/api/superadmin/locations", jsonData, config);

            console.log('Response:', response);

            if (response && response.status === 201) {
                this.setState({ submissionStatus: 'success' });
                console.log('Form submitted successfully');
                setTimeout(() => {
                    window.location.href = "/list-location";
                }, 2000);
            } else {
                console.log('Unexpected response:', response);
            }

        } catch (error) {
            console.error('Error submitting form:', error);

            if (error.response) {
                const { status, data } = error.response;
                if (status === 400) {
                    console.error('Bad request error:', data);
                } else if (status === 401) {
                    console.error('Unauthorized error, please log in again.');
                } else {
                    console.error('Error response:', error.response);
                }
            } else {
                console.error('Network or other error:', error);
            }
        }
    };

    render() {
        const { name, pinCodes, submissionStatus } = this.state;
        return (
            <div className="col-md-12">
                <form onSubmit={this.handleSubmit}>
                    <div className="card">
                        <div className="header">
                            <h2>Add Location</h2>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="name"
                                            value={name}
                                            onChange={this.handleChange}
                                            placeholder="Location Name"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Pin Codes (comma separated)</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={pinCodes}
                                            onChange={this.handlePinCodeChange}
                                            placeholder="Enter pin codes separated by commas"
                                        />
                                    </div>
                                    {submissionStatus === 'success' && (
                                        <div className="alert alert-success" role="alert">
                                            Form submitted successfully!
                                        </div>
                                    )}
                                    <button
                                        className="btn btn-primary"
                                        type="submit"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(AddLocation);
